/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiInsertionType;
(function (ApiInsertionType) {
    ApiInsertionType["IT_UNSPECIFIED"] = "IT_UNSPECIFIED";
    ApiInsertionType["APPEND"] = "APPEND";
    ApiInsertionType["PREPEND"] = "PREPEND";
    ApiInsertionType["REPLACE"] = "REPLACE";
})(ApiInsertionType || (ApiInsertionType = {}));
export function ApiInsertionTypeFromJSON(json) {
    return ApiInsertionTypeFromJSONTyped(json, false);
}
export function ApiInsertionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiInsertionTypeToJSON(value) {
    return value;
}
